module.exports = __webpack_public_path__ + "static/media/order_icon28.966bcd14.png";